import { QuestionCircleOutlined } from '@ant-design/icons'
import { Popover } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const PriorityPopoverDescription = () => {
  const { t } = useTranslation()
  return (
    <Popover
      trigger='click'
      content={
        <div>
          <p>
            <div>{t('production.detail.attributeDescription1')}</div>
            <div>{t('production.detail.attributeDescription2')}</div>
            <div>{t('production.detail.attributeDescription3')}</div>
          </p>
          <span>{t('production.detail.attributeDescription4')}</span>
          <div>{t('production.detail.attributeDescription5')}</div>
          <p>{t('production.detail.attributeDescription6')}</p>
          <span>{t('production.detail.attributeDescription7')}</span>
          <p>{t('production.detail.attributeDescription8')}</p>
          <span>{t('production.detail.attributeDescription9')}</span>
          <p>{t('production.detail.attributeDescription10')}</p>
        </div>
      }
    >
      <QuestionCircleOutlined className='ml-4px text-gray-500' />
    </Popover>
  )
}
